import React, { useState, useLayoutEffect, useContext } from 'react';

import * as S from './styles';
import TabsMaterial from 'components/TabsMaterial';
import DynamicPageContext from 'context/DynamicPage';
import { tabsList } from './listTabsflag';
import DataFormRedirectableLinks from 'components/DataFormRedirectableLinks';
import AddRedirectableLink from 'components/AddRedirectableLink';
import { DataFormProps } from 'types/InputsRedirectableLinkProps';
import { verifyIfFormCanSave } from './functions';

const initialData: DataFormProps = {
	title: '',
	type: '',
	paddingTop: 0,
	paddingBottom: 0,
	schedule: {
		countdown: false,
		end: '',
		start: '',
		timezone: 'America/Sao_Paulo'
	},
	links: []
};

export default function InputsRedirectableLinks() {
	const {
		moduleInSavingMode,
		setModuleInSavingMode,
		setCanSaveModuleOnBack,
		setMessageErrorForm,
		moduleOnPhoneToEdit,
		setModuleOnPhoneToEdit
	} = useContext(DynamicPageContext);

	const [dataForm, setDataForm] = useState(initialData);
	const [tabSelected, setTabSelected] = useState(0);

	useLayoutEffect(() => {
		//se esta criando um novo componente
		if (moduleInSavingMode !== null) {
			setModuleInSavingMode((obj) => {
				if (obj) {
					return { ...obj, data: dataForm };
				}
				return obj;
			});
		} else {
			//se esta editando um componente
			setModuleOnPhoneToEdit((obj) => {
				if (obj) {
					return { ...obj, data: dataForm };
				}
				return obj;
			});
		}

		verifyIfFormCanSave(dataForm, setCanSaveModuleOnBack, setMessageErrorForm);
	}, [dataForm]);

	//se estiver em edição aqui pega os dados do item editado
	useLayoutEffect(() => {
		if (moduleOnPhoneToEdit !== null && moduleInSavingMode === null) {
			setTimeout(() => {
				setDataForm((obj) => ({ ...obj, ...moduleOnPhoneToEdit.data }));
			}, 100);
		}
	}, []);

	return (
		<S.container>
			<TabsMaterial listTabs={tabsList} getPage={setTabSelected} />

			<DataFormRedirectableLinks
				isShow={tabSelected === 0}
				dataForm={dataForm}
				setDataForm={setDataForm}
			/>

			<AddRedirectableLink
				isShow={tabSelected === 1}
				dataForm={dataForm}
				setDataForm={setDataForm}
			/>
		</S.container>
	);
}
